import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import Fetch from '../../../../core/util/core/Fetch';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/entities/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDeleteEmployees: `${config.endpoints.backend}entityemployees/deleteByEntity`,
        endpointDelete: `${config.endpoints.backend}entities/delete`,
        endpoint: config.endpoints.backend + 'entities/getall'
    }

    let list = {
        labelTitle: 'Lista de Entidades',
        labelTitleButtonAdd: 'Incluir nova entidade',
        fieldsShowOnDelete: ['corporate_name'],
        showPrintButtons: true,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'cnpj',
                label: 'CNPJ'
            },
            {
                name: 'corporate_name',
                label: 'Razão Social'
            },
            {
                name: 'fantasy_name',
                label: 'Nome Fantasia'
            },
            {
                name: 'status',
                label: 'Status',
                width: '10%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
